var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.avatars.length)?_c('div',{staticClass:"playerAvatar placeholder",style:({
    width: `${_vm.scale * 20}px`,
    height: `${_vm.scale * 20}px`,
  })},[_vm._m(0)]):_vm._e(),_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.$t('account.PlayerAvatarPlaceholder')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('span',{staticClass:"questionmark"},[_vm._v("?")])])
}]

export { render, staticRenderFns }